import React from "react";
import { Outlet } from "react-router";

function SignupForm() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default SignupForm;
